import { useContext } from 'react';

import { RowContext } from '#src/rows/RowContext.js';
import { selectFields } from '#src/lib/contentful/selectors.mjs';
import { logger } from '#src/lib/logger';

import { TYPES, linkType } from './types.js';

/**
 * If the contentful link includes a contextQueryParam value this hook will attempt to append a query param by that name with the RowContext value.
 * This allows us to pass context information through utm_content (or whatever) without having to create a separate contentful link for each place it's used.
 * This is used for the homepage CTAs that link to the quiz, for example.
 *
 * @param {{ link: string, contextQueryParam: string }} linkEntry - The contentful 'link' entry.
 * @returns {object}
 */
export const useRowContextParam = (linkEntry) => {
  const rowContext = useContext(RowContext);
  if (!rowContext) {
    return linkEntry;
  }

  try {
    const { link, contextQueryParam } = linkEntry
      ? selectFields(linkEntry)
      : {};
    if (contextQueryParam && linkType(link) === TYPES.FULL_URL) {
      const url = new URL(link);
      if (!url.searchParams.has(contextQueryParam)) {
        url.searchParams.set(contextQueryParam, rowContext);
      }
      return {
        ...linkEntry,
        fields: {
          ...linkEntry.fields,
          link: url.toString(),
        },
      };
    }
  } catch (e) {
    logger?.warn?.(e);
  }

  return linkEntry;
};
